module.exports = __webpack_public_path__ + "img/edit.6d189f84.svg";